import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { filter, map, startWith } from "rxjs";
import { MobileBottomNavItem } from "../mobile-navigation.models";
import { isBottomNavItemActive } from "./mobile-bottom-nav-active.helper";

@Component({
  selector: "mobile-bottom-nav",
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: "./bottom-nav.component.html",
  styleUrl: "./bottom-nav.component.scss",
})
export class BottomNavComponent {
  @Input({ required: true }) items: MobileBottomNavItem[] = [];

  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  isActive(item: MobileBottomNavItem): boolean {
    const routes = this.items.map((entry) => entry.Route);
    return isBottomNavItemActive(item.Route, this.currentUrl() ?? "", routes);
  }
}
